import { render, staticRenderFns } from "./ChatGpt.vue?vue&type=template&id=4da34952&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatGpt.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/ChatGpt.vue
// module id = 2385
// module chunks = 1